import React, { FC, useState } from 'react'
import AvatarConnector, { ConnectorProps as AvatarProps } from 'connectors/Avatar'
import { LoadingSpinner } from 'styles/loader'
import { uploadAvatarImage } from 'apis/private/uploadAvatar'
import UploadIcon from 'svg/upload-v2.svg'
import { updateImagePathBasedOnHostName } from '../../helpers'
import styles from './Header.module.scss'
import useQA from 'hooks/useQA'
import { UploadAvatarImageApiType } from '../../types'
type Props = AvatarProps & {
  userID: number
  avatar: string
}

const uploadAvatarImageApi = async ({
  imageFile,
  callbackFunc,
  addMessage,
}: UploadAvatarImageApiType) => {
  const heroImageApi = await uploadAvatarImage(imageFile)

  if (heroImageApi.success) {
    const { medImage } = heroImageApi.payload
    callbackFunc({
      avatarImg: medImage,
    })
  } else {
    const { errorMessage } = heroImageApi.payload
    let flashErrorMessage = 'Profile image could not be uploaded'

    if (errorMessage) {
      flashErrorMessage = errorMessage
    }

    addMessage(flashErrorMessage, 'error')
    callbackFunc({
      isLoading: false,
    })
  }
}

const Avatar: FC<Props> = (props) => {
  const { userID, sessionUserID, avatar, addMessage } = props
  const [state, handleState] = useState({
    isLoading: false,
    avatarImg: avatar,
  })
  const { isLoading, avatarImg } = state
  const myOwnAccount = sessionUserID === Number(userID)
  const { testId } = useQA()
  const onFileChanged = async (ev: React.SyntheticEvent<HTMLInputElement>) => {
    ev.preventDefault()
    const input = ev.target as HTMLInputElement
    if (input.files && input.files.length) {
      handleState((prevState) => ({ ...prevState, isLoading: true }))
      uploadAvatarImageApi({
        imageFile: input.files[0],
        callbackFunc: (data: Record<string, any>) => {
          handleState((prevState) => ({ ...prevState, isLoading: false, ...data }))
        },
        addMessage,
      })
    }
  }

  if (!avatar && !myOwnAccount) {
    return null
  }

  return (
    <div className={styles.avatar} {...testId('avatar')}>
      {isLoading && (
        <>
          <div className={styles.overlay} />
          <LoadingSpinner className={styles.loader} />
        </>
      )}
      {avatar && (
        <>
          <img
            src={updateImagePathBasedOnHostName(avatarImg)}
            className={styles.userAvatar}
            alt='profile avatar'
            role='presentation'
            itemProp='image'
          />

          {myOwnAccount && (
            <div className={styles.editAvatarSection}>
              <input
                className={styles.editInput}
                type='file'
                accept='image/png, image/jpeg, image/jpg'
                onChange={onFileChanged}
                aria-label='hidden'
              />
              <p>Edit Photo</p>
            </div>
          )}
        </>
      )}
      {myOwnAccount && !avatar && (
        <div className={styles.uploadAvatarSection}>
          <div className={styles.uploadAvatar}>
            <UploadIcon />
          </div>
          <input
            className={styles.uploadInput}
            type='file'
            accept='image/png, image/jpeg, image/jpg'
            onChange={onFileChanged}
            aria-label='hidden'
          />
          <p>Add Photo</p>
        </div>
      )}
    </div>
  )
}

export default AvatarConnector(Avatar)
